export function formatDistanceKm(distanceKm: number | undefined): string | undefined {
  if (distanceKm === undefined || distanceKm === null || distanceKm <= 0) {
    return undefined;
  }
  const rounded = Math.round(distanceKm * 10) / 10;
  return `${rounded} km`;
}

export function formatDistanceMetersToMiles(
  meters: number | undefined | null,
  options?: { fallback?: string }
): string {
  if (!meters) return options?.fallback ?? 'N/A';
  const miles = meters / 1609.34;
  return `${miles.toFixed(1)} mi`;
}
